export const SUCCESS_CODE = 'SUCC-0000'
export const BASE_CODE = 'BASE-0002'
export const FAILURE_CODE = 'FAIL-0002'
export const REPEAT_CODE = 'REPE-0000'
export const FAIL_CODE = 'FAILURE-0001'
// 查无此车
export const FAIL_CODE_NO_CAR = 'FAILURE-0002'
// 重复发送验证码
export const FAIL_CODE_REPEAT_PHONE_NUMBER = 'FAILURE-0003'
// 3分钟内不能发送验证码
export const REPEAT_VERIFICATION_CODE = 'FAILURE-0004'
// 已绑定的车辆不能绑定其他会员
export const REPEAT_CAR_NUMBER = 'FAILURE-0005'
export const ERROR_CODE = 400
export const VERIFY_CODE_FAIL = 'FAILURE-0001'
// 方案名重复
export const REPEAT_PROGRAM_NAME = 'FAILURE_001'
// 重复提交方案
export const REPEAT_SUBMIT_PROGRAM = 'FAILURE_002'
// 方案中没有卡券
export const PROGRAM_NO_COUPON = 'FAILURE_003'



// WEBPACK FOOTER //
// ./src/constants/ReturnCodesConstants.js